//required for redux toolkit:
window.process = {
    env: {
        NODE_ENV: 'development'
    }
}

if (new URLSearchParams(location.search).has('popup')) {
    document.body.classList.add('nc-popup');
}



